export default __webpack_public_path__ + "static/media/bannerImgUpgrade.6e6c4bf0.png";